import BtcImg from "../assets/cryptoLogo/btc.png"
import EthImg from "../assets/cryptoLogo/eth.png"
import BnbImg from "../assets/cryptoLogo/bnb.png"
import SolImg from "../assets/cryptoLogo/sol.png"
import XrpImg from "../assets/cryptoLogo/xrp.png"
import AvaxImg from "../assets/cryptoLogo/avax.png"
import TrxImg from "../assets/cryptoLogo/trx.png"
import DotImg from "../assets/cryptoLogo/polkadot.png"
import AdaImg from "../assets/cryptoLogo/ada.png"
import ManaImg from "../assets/cryptoLogo/mana.png"
import SandImg from "../assets/cryptoLogo/sand.png"
import AxsImg from "../assets/cryptoLogo/axs.png"
import DogeImg from "../assets/cryptoLogo/doge.png"
import CakeImg from "../assets/cryptoLogo/cake.png"
import BchImg from "../assets/cryptoLogo/bch.png"
import FilImg from "../assets/cryptoLogo/fil.png"
import BakeImg from "../assets/cryptoLogo/bake.png"
import ApeImg from "../assets/cryptoLogo/ape.png"
import GnoImg from "../assets/cryptoLogo/gno.png"
import MaticImg from "../assets/cryptoLogo/matic.png"
import CeloImg from "../assets/cryptoLogo/celo.png"
import CroImg from "../assets/cryptoLogo/cro.png"
import VelvetCapitalLogo from "../assets/img/newvelvetcapitallogo.svg"
import MkrImg from "../assets/cryptoLogo/mkr.png"
import UniImg from "../assets/cryptoLogo/uni.png"
import CompImg from "../assets/cryptoLogo/comp.png"
import BalImg from "../assets/cryptoLogo/bal.png"
import AaveImg from "../assets/cryptoLogo/aave.png"
import LinkImg from "../assets/cryptoLogo/link.png"
import GhstImg from "../assets/cryptoLogo/ghst.png"
import QuickImg from "../assets/cryptoLogo/quick.png"
import Ghst2Img from "../assets/cryptoLogo/ghst2.svg"

export default {
    BTC: BtcImg,
    ETH: EthImg,
    BNB: BnbImg,
    SOL: SolImg,
    XRP: XrpImg,
    AVAX: AvaxImg,
    ADA: AdaImg,
    DOT: DotImg,
    TRX: TrxImg,
    MANA: ManaImg,
    SAND: SandImg,
    AXS: AxsImg,
    BAKE: BakeImg,
    APE: ApeImg,
    DOGE: DogeImg,
    CAKE: CakeImg,
    BCH: BchImg,
    FIL: FilImg,
    GNO: GnoImg,
    xDAI: GnoImg,
    MATIC: MaticImg,
    CELO: CeloImg,
    CRO: CroImg,
    TOP5: VelvetCapitalLogo,
    MKR: MkrImg,
    UNI: UniImg,
    COMP: CompImg,
    BAL: BalImg,
    LINK: LinkImg,
    AAVE: AaveImg, 
    GHST: Ghst2Img,
    QUICK: QuickImg
}
